import { FEATURE_SOURCE, GEOJSON_FEATURE_COLLECTION, GEOJSON_PROPERTY } from './constants';
import type { Feature, GeoJSONSource, LayerStyle, Map } from './types';

const drawingLayers = () => {
    const initialize = (map: Map, layers?: LayerStyle[]) => {
        initializeDrawingSource(map);

        if (!layers) {
            return;
        }

        initializeDrawingLayers(map, layers);
    };

    const initializeDrawingSource = (map: Map) => {
        map.addSource(FEATURE_SOURCE.DRAWING, {
            data: {
                features: [],
                type: GEOJSON_FEATURE_COLLECTION
            },
            type: 'geojson'
        });
    };

    const initializeDrawingLayers = (map: Map, drawingStyles: LayerStyle[]) => {
        drawingStyles.forEach(drawingStyle => addDrawingLayer(map, drawingStyle));
    };

    const addDrawingLayer = (map: Map, drawingStyle: LayerStyle) => {
        const { name, style, type } = drawingStyle;

        map.addLayer({
            filter: ['==', ['get', 'layer'], name],
            id: name,
            layout: {},
            paint: style,
            source: FEATURE_SOURCE.DRAWING,
            type
        });
    };

    const updateFeatures = (map: Map, features: Feature[]) => {
        const drawingFeatures = features.filter(feature => {
            const referencedBoundaryId =
                feature.properties?.[GEOJSON_PROPERTY.REFERENCED_BOUNDARY_ID];

            return (
                (referencedBoundaryId === undefined || referencedBoundaryId === null) &&
                !feature.properties?.[GEOJSON_PROPERTY.IS_STATIC]
            );
        });
        const mapSource = map.getSource(FEATURE_SOURCE.DRAWING) as GeoJSONSource;

        if (mapSource) {
            mapSource.setData({
                features: drawingFeatures,
                type: GEOJSON_FEATURE_COLLECTION
            });
        }
    };

    return {
        initialize,
        updateFeatures
    };
};

export default drawingLayers;
